/**
 * Dates as dd/mm/aa. The new report tables carry many date columns, and the two
 * digit year is what keeps them inside 1366px without horizontal scrolling. The
 * full date stays available in the row tooltip.
 */
export function formatDiaCurto(date: string | null | undefined): string {
  if (date === null || date === undefined || date === '') {
    return '-';
  }
  const [year, month, day] = date.split('-');
  return `${day}/${month}/${year.slice(2)}`;
}

/** Dates as dd/mm/aaaa, for tooltips and headers where width is not at stake. */
export function formatDiaLongo(date: string | null | undefined): string {
  if (date === null || date === undefined || date === '') {
    return '-';
  }
  const [year, month, day] = date.split('-');
  return `${day}/${month}/${year}`;
}

export function formatHoras(horas: number): string {
  return `${horas.toLocaleString('pt-BR', { maximumFractionDigits: 1 })} h`;
}

export function formatPercentual(valor: number | null): string {
  if (valor === null) {
    return '-';
  }
  return `${valor.toLocaleString('pt-BR', { maximumFractionDigits: 1 })}%`;
}

/** A signed reading of business days, so a flat date never looks like a delay. */
export function formatDiasUteis(dias: number | null): string {
  if (dias === null) {
    return '-';
  }
  return dias > 0 ? `+${dias}` : String(dias);
}
